import React from 'react';

interface CardProps {
    id: string
    name: string
    description?: string
    size?: number
}

export const Card: React.FunctionComponent<CardProps> = ({
        name,
        description,
        size = 50
    }) => {
    return (
        <div style={{ border: "1px solid gray"}}>
            <div>{name}</div>
            <div>{description}</div>
            <div>{size}</div>
        </div>
    )
}